var _style, _switch;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisaWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 216 216",
    style: {
      enableBackground: "new 0 0 216 216"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#1A1F71;}\n")), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    requiredExtensions: "&ns_ai;",
    x: 0,
    y: 0,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M144.4,128.2c0,1.5-1.2,2.7-2.7,2.7H74.5c-1.5,0-2.7-1.2-2.7-2.7V87.8c0-1.5,1.2-2.7,2.7-2.7h67.2 c1.5,0,2.7,1.2,2.7,2.7V128.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.4,98.4l-8.1,19.3H86l-4-15.4c-0.2-0.9-0.5-1.3-1.2-1.7c-1.2-0.6-3.2-1.3-4.9-1.6l0.1-0.6h8.5 c1.1,0,2.1,0.7,2.3,2l2.1,11.2l5.2-13.1H99.4z M120.1,111.4c0-5.1-7-5.4-7-7.6c0-0.7,0.7-1.4,2.1-1.6c0.7-0.1,2.7-0.2,4.9,0.9 l0.9-4.1c-1.2-0.4-2.7-0.9-4.7-0.9c-4.9,0-8.4,2.6-8.4,6.4c0,2.8,2.5,4.3,4.4,5.2c1.9,0.9,2.6,1.5,2.6,2.4c0,1.3-1.5,1.9-3,1.9 c-2.5,0-4-0.7-5.1-1.2l-0.9,4.2c1.2,0.5,3.3,1,5.5,1C116.6,118,120,115.4,120.1,111.4 M133.1,117.7h4.6l-4-19.3h-4.3 c-1,0-1.8,0.6-2.1,1.4l-7.5,17.9h5.2l1-2.9h6.4L133.1,117.7z M127.5,110.9l2.6-7.2l1.5,7.2H127.5z M106.5,98.4l-4.1,19.3h-5 l4.1-19.3H106.5z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaWhite);
export default __webpack_public_path__ + "static/media/VisaWhite.0b80f78b.svg";
export { ForwardRef as ReactComponent };